/*
 * @Description: 网络请求封装
 */

import { translate } from './i18n/index.js';

// ---------------------------------------------------------------------------

/**
 * 是否测试中
 */
let DEBUG = false;

/**
 * 服务器url
 */
let Host = '';

// 请求域名
if (process.env.NODE_ENV === 'development') {
	// console.log('开发环境')
	Host = 'https://thsy.preschool.zone';
} else {
	// console.log('生产环境')
	Host = 'https://thsy.preschool.zone';
}

// ---------------------------------------------------------------------------

/**
 * 网络请求封装
 * @param {*} url 地址
 * @param {*} data 请求数据
 * @param {*} method 请求方式
 * @param {*} route 路由地址
 * @param {*} header 响应头信息
 */
function http(url, data = {}, method = 'POST', route = '/OA/', header = {}) {
	return new Promise((resolve, reject) => {
		const that = this;

		header = {
			'content-type': 'application/json',
			...header
		};

		if (header['content-type'] === 'application/x-www-form-urlencoded') {
			data = processData(data);
		}

		if (DEBUG) data['debug'] = 1;

		url = `${Host}${route}${url}`;

		uni.request({
			url,
			data,
			method,
			header,
			withCredentials: true, // 关键，携带 cookie
			forceCellularNetwork: false,
			success(res) {
				if (res.statusCode === 200) {
					if (res.data?.reason === 'timeout') {
						uni.hideLoading();

						const first_login_flag = !uni.getStorageSync('FirstLogin');

						const pages = getCurrentPages();
						const curPage = pages[pages.length - 1];
						if (!curPage) return;

						const { route } = curPage;
						if (!route) return;

						if (first_login_flag) {
							uni.reLaunch({
								url: '/pages/login/login'
							});
							return;
						} else if (route === 'pages/login/login') {
							return;
						}

						that.showModal(res.data.msg, getApp().translate('SYSTEM_PROMPT'), true, getApp().translate('OK'), (result) => {
							result.confirm && uni.reLaunch({
								url: '/pages/login/login'
							});
						});
						return;
					}
					resolve(res);
				} else {
					uni.hideLoading();
					that.showModal(getApp().translate('REQUEST_FAILED_WITH_CODE', { statusCode: res.statusCode }));
					reject(res);
				}
			},
			fail(err) {
				uni.hideLoading();
				that.showModal(getApp().translate('REQUEST_FAILED'));
				reject(err);
			}
		});
	})
}


/**
 * GET请求封装
 * @param {*} url 地址
 * @param {*} data 请求数据
 * @param {*} route 路由地址
 * @param {*} header 响应头信息
 */
async function GET(url, data = {}, route = '/OA/', header = {}) {
	return await http(url, data, 'GET', route, header);
}

/**
 * POST请求封装
 * @param {*} url 地址
 * @param {*} data 请求数据
 * @param {*} route 路由地址
 * @param {*} header 响应头信息
 */
async function POST(url, data = {}, route = '/OA/', header = {}) {
	return await http(url, data, 'POST', route, header);

}


/**
 * 遍历 data 对象，自动处理其中的数组，将其转换为适合 application/x-www-form-urlencoded 格式的字符串
 * @param {Object} data
 */
function processData(data) {
	let formData = new URLSearchParams();
	// 遍历 data 中的每一项
	Object.keys(data).forEach(key => {
		if (Array.isArray(data[key])) {
			// 如果是数组，遍历数组并生成 `key[]` 的形式
			data[key].forEach(item => {
				formData.append(`${key}[]`, item);
			});
		} else {
			formData.append(key, data[key]);
		}
	});
	return formData.toString(); // 返回正确的查询字符串
}

// ---------------------------------------------------------------------------

/**
 * 检查资源是否含域名
 * @param {Object} url
 * @return {String} 返回url地址
 */
function checkHost(url) {
	const host = Host;
	return (url && !url.startsWith(host)) ? (host + url) : url;
}

// ---------------------------------------------------------------------------

export default {
	value: { Host },
	method: {
		http,
		GET,
		POST,
		checkHost,
	}
};